// extracted by mini-css-extract-plugin
export default {"oil-selection":"OilSelection_oil-selection__ercvw","dropdown":"OilSelection_dropdown__FT8bi","open":"OilSelection_open__-J6Om"};